/**
 * Set while a sign-out runs (ApiProvider.logoutUserLocally), until the page
 * navigates away. The app's stored data is cleared at the start of sign-out,
 * so a page still on screen may fail to render in that moment; the error
 * screens show nothing instead of "Oops!". Every sign-out ends in a page
 * load, which resets this.
 */
let signingOut = false;

export const markSigningOut = (): void => {
  signingOut = true;
};

export const isSigningOut = (): boolean => signingOut;
